// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  pageWrapper: {
    marginTop: theme.spacing(4),
    width: '100%',
    padding: `0 ${theme.spacing(10)}`,
  },
  header: {
    marginTop: theme.spacing(2.5),
    display: 'flex',
    justifyContent: 'space-between',
  },
  divider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  headCell: {
    color: theme.palette.darkGrey,
    textTransform: 'uppercase',
    verticalAlign: 'top',
    fontSize: '16px',
  },
  cellText: {
    color: theme.palette.darkGrey,
    fontWeight: 400,
    fontSize: '16px',
  },
  window: {
    display: 'flex',
    flexDirection: 'column',
  },
  spinnerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  emptyState: {
    color: theme.palette.darkGrey,
    padding: theme.spacing(2, 0),
  },
  end: {
    height: theme.spacing(6),
  },
});

export default styles;
